import { useRef, useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import useModalStore from '../../../zustand/store/useModalStore.js';
import { useShallow } from 'zustand/shallow';
import ToastModal from '../../../component/common/modal/ToastModal.jsx';
import ConfirmModal from '../../../component/common/modal/ConfirmModal.jsx';
import { resetAuthExit } from '../../../component/AxiosCORS';

import '../../../css/login.css';
import * as Icons from '../../../images/icons/icons_component.js';
import * as Theme from '../../../images/icons/icons_theme';

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [otp, setOtp] = useState(Array(6).fill(''));
    const inputs = useRef([]);
    const [userInfo, setUserInfo] = useState({
        useridno: '',
        userpswd: '',
        inputOtp: ''
    });
    const [loginStep, setLoginStep] = useState('first_step');
    const [showPassword, setShowPassword] = useState(false);
    const [isIdFocused, setIsIdFocused] = useState(false);
    const [isPwFocused, setIsPwFocused] = useState(false);
    const [isError, setIsError] = useState('');
    const [failCount, setFailCount] = useState(0);

    const [otpInfo, setOtpInfo] = useState({
        otpurl: '',
        otpkey: ''
    })

    // notice modal
    const [notiModal, confirmModal, showNotiModal, toastState] = useModalStore(
        useShallow((state) => [state.notiModal, state.confirmModal, state.showNotiModal, state.toastState]));

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...userInfo,
            [name]: value
        };
        setUserInfo(newParams);
    };
    const handleOtpChange = (value, index) => {
        if (!/^[0-9]?$/.test(value)) return; // 숫자만 허용
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);
        // 다음 input으로 이동
        if (value && index < 5) {
            inputs.current[index + 1].focus();
        }
    };

    const handleClearAll = () => {
        // 1. 모든 칸을 빈 문자열로 초기화
        setOtp(['', '', '', '', '', '']);

        // 2. 에러 상태가 있다면 함께 초기화 (isError가 상태일 경우)
        if (typeof setIsError === 'function') setIsError(false);

        // 3. 첫 번째 입력 칸으로 포커스 이동 (사용자 편의성)
        if (inputs.current[0]) {
            inputs.current[0].focus();
        }
    };

    const activeEnter = (e) => {
        if (notiModal || confirmModal) {
            e.preventDefault();
            return;
        }
        if (e.key === 'Enter') {
            if(((loginStep === 'first_step' && userInfo.useridno !== '' && userInfo.userpswd !== '') || ((loginStep === 'otp_issuance' || loginStep === 'otp_login') && isOtpComplete)))
            login();
        }
    };

    const reIssuance = async () => {
        setLoginStep('otp_issuance');
        const response = await axios.get('/commonapi/otpReissuance.do',
            { params: userInfo }
        );
        setOtpInfo({
            otpurl: response.data.otpResult.url,
            otpkey: response.data.otpResult.encodedKey
        });
        setOtp(Array(6).fill(''));
    };

    const signIn = () => {
        navigate('/member/joinPage.do');
    };

    const findIdPw = () => {
        navigate('/member/findPage.do');
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            if (otp[index] === '') {
                // 현재 칸이 비어있으면 이전 칸으로 이동
                if (index > 0) {
                    inputs.current[index - 1].focus();
                }
            } else {
                // 현재 칸 내용 삭제
                const newOtp = [...otp];
                newOtp[index] = '';
                setOtp(newOtp);
            }
        }
        if (notiModal || confirmModal) {
            e.preventDefault();
            return;
        }
        if (e.key === 'Enter') {
            login();
        }
    };

    const isOtpComplete = otp.every((value) => value.trim() !== "" && value.length === 1);

    const back = () => {
        if (loginStep === 'otp_issuance') {
            setLoginStep('otp_login');
        } else {
            setLoginStep('first_step');
        }
        setIsError('');
        setOtp(Array(6).fill(''));
    };

    const login = async () => {
        try {
            if (loginStep === 'first_step') {
                const response = await axios.get('/commonapi/executeLogin.do',
                    { params: userInfo },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    }
                );
                if (response.data.loginResult.isLogin) {
                    if (response.data.otpExceptChk === 1) {
                        // OTP 예외자: executeOtpLogin 호출로 Redis 토큰 발급 시점 통일
                        const exceptResponse = await axios.get('/commonapi/executeOtpLogin.do', {
                            params: { useridno: userInfo.useridno }
                        });
                        if (exceptResponse.data.isOtpLogin) {
                            localStorage.setItem('userAuth', exceptResponse.data.userSession.userAuth);
                            localStorage.setItem('useremcd', exceptResponse.data.userSession.useremcd);
                            localStorage.setItem('emogdesc', exceptResponse.data.userSession.emogdesc);
                            localStorage.setItem('userotpenccode', exceptResponse.data.userSession.userotpenccode);
                            localStorage.setItem('id', exceptResponse.data.userSession.id);
                            localStorage.setItem('roleno', exceptResponse.data.userSession.roleno);
                            localStorage.setItem('emoggrdc2', exceptResponse.data.userSession.emoggrdc2);
                            localStorage.setItem('emogloca', exceptResponse.data.userSession.emogloca);
                            localStorage.setItem('name', exceptResponse.data.userSession.name);
                            localStorage.setItem('superAdmin', exceptResponse.data.userSession.superAdmin);
                            localStorage.setItem('userprjt', exceptResponse.data.userSession.userprjt);
                            localStorage.setItem('userstrm', exceptResponse.data.userSession.userstrm);
                            localStorage.setItem('admnUserMng', exceptResponse.data.userSession.admnUserMng);
                            localStorage.setItem('admnAuditLog', exceptResponse.data.userSession.admnAuditLog);
                            localStorage.setItem('admnExceldownLog', exceptResponse.data.userSession.admnExceldownLog);
                            localStorage.setItem('overYn', exceptResponse.data.userSession.overYn);
                            axios.defaults.headers.common['Authorization'] = `Bearer ${exceptResponse.data.token}`;
                            resetAuthExit();
                            navigate('/');
                        }
                    } else {
                        if (response.data.loginResult.userSession.userotpenccode != null) {
                            setLoginStep('otp_login');
                            setIsError('');
                            setOtpInfo({
                                otpurl: '',
                                otpkey: response.data.loginResult.userSession.userotpenccode
                            });
                        } else {
                            setLoginStep('otp_issuance');
                            setIsError('');
                            setOtpInfo({
                                otpurl: response.data.otpResult.url,
                                otpkey: response.data.otpResult.encodedKey
                            });
                        }
                    };
                    setFailCount(0);
                } else {
                    setIsError(response.data.loginResult.resultMessage);
                    setFailCount(response.data.loginResult.failCount);
                    showNotiModal(response.data.loginResult.resultMessage);
                    setIsIdFocused(false);
                    setIsPwFocused(false);
                    setShowPassword(false);
                }
            } else {
                const totalObj = Object.assign({}, userInfo, otpInfo);
                const response2 = await axios.get('/commonapi/executeOtpLogin.do',
                    { params: totalObj },
                    {
                        headers: {
                            'Content-Type': 'application/json',
                        }
                    }
                );
                if (response2.data.isOtpLogin) {
                    localStorage.setItem('userAuth', response2.data.userSession.userAuth);
                    localStorage.setItem('useremcd', response2.data.userSession.useremcd);
                    localStorage.setItem('emogdesc', response2.data.userSession.emogdesc);
                    localStorage.setItem('userotpenccode', response2.data.userSession.userotpenccode);
                    localStorage.setItem('id', response2.data.userSession.id);
                    localStorage.setItem('roleno', response2.data.userSession.roleno);
                    localStorage.setItem('emoggrdc2', response2.data.userSession.emoggrdc2);
                    localStorage.setItem('emogloca', response2.data.userSession.emogloca);
                    localStorage.setItem('name', response2.data.userSession.name);
                    localStorage.setItem('superAdmin', response2.data.userSession.superAdmin);
                    localStorage.setItem('userprjt', response2.data.userSession.userprjt);
                    localStorage.setItem('userstrm', response2.data.userSession.userstrm);
                    localStorage.setItem('admnUserMng', response2.data.userSession.admnUserMng);
                    localStorage.setItem('admnAuditLog', response2.data.userSession.admnAuditLog);
                    localStorage.setItem('admnExceldownLog', response2.data.userSession.admnExceldownLog);
                    localStorage.setItem('overYn', response2.data.userSession.overYn);
                    axios.defaults.headers.common['Authorization'] = `Bearer ${response2.data.token}`;
                    setFailCount(0);
                    resetAuthExit();
                    navigate('/');
                } else {
                    setIsError(response2.data.resultMessage);
                    setFailCount(response2.data.failCount);
                    showNotiModal(response2.data.resultMessage, {
                        onConfirm: () => {
                            handleClearAll();
                        }
                    });
                }
            }

        } catch (e) {
            console.log(e);
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    };

    const togglePassword = () => setShowPassword((prev) => !prev);

    useEffect(() => {
        setUserInfo((prev) => ({
            ...prev,
            inputOtp: otp.join(''),
        }));
    }, [otp]);

    const errorMsg = isError && (
        <div className='noti_error'>
            {isError}
            {failCount <= 5 && loginStep === 'first_step' && `(${failCount})`}
        </div>
    )

    useEffect(() => {
        inputs.current[0]?.focus();
    }, [loginStep]);

    return (
        <div className='main_container'>
            {!toastState ? '' : <ToastModal />}
            <div className='login_container'>
                {loginStep === 'otp_issuance' ?
                    <div className='download_wrapper'>
                        <p className='announce_desription'><Icons.FaceDalgu16 />&ensp;OTP 인증을 위해서는 구글의 OTP 어플을 핸드폰에 설치하셔야 합니다!</p>
                        <div className='qr_down_container'>
                            <div className='flex flex-col items-center gap-5'>
                                <Icons.QrAndroidImg />
                                <p className='text-center'>
                                    안드로이드 사용자의 경우 상단의 QR코드를<br />
                                    스캔하여 다운로드 합니다.
                                </p>
                                <span className='down_link_text'>Google Play 링크</span>
                            </div>
                            <div className='flex flex-col items-center gap-5'>
                                <Icons.QrIosImg />
                                <p className='text-center'>
                                    IOS 사용자의 경우 상단의 QR코드를<br />
                                    스캔하여 다운로드 합니다.
                                </p>
                                <span className='down_link_text'>App Store 링크</span>
                            </div>
                        </div>
                    </div>
                    :
                    // <div className='image-section'></div>
                    <div className='login_img_box overflow-hidden'><Icons.MainLoginImg className='object-cover' preserveAspectRatio='xMidYMid slice' /></div>
                }
                <hr className='h-auto border-l mx-4' />

                <div className='form_section'>
                    <div className='login_wrapper'>
                        <div className='flex flex-col items-center'>
                            <div className='siren_media_set'><Icons.SirenIco /></div>
                            <h1>국가응급진료정보망</h1>
                            <h2 className='co_gray'>NEDIS 시스템</h2>
                        </div>
                        <hr className='w-full' />
                        <div className='login_input_form flex flex-col gap-4'>
                            {loginStep === 'first_step' ?
                                <>
                                    {errorMsg}
                                    <div className='idpw_input_box'>
                                        <div className={`idpw_input items-center ${isError && !isPwFocused ? 'idpw_input_error' : ''}`}>
                                            <div className='border-r pr-2 mr-2 items-center'>
                                                <Theme.InputId className={isIdFocused ? 'co_dark' : isError ? 'co_red' : 'co_light'} />
                                            </div>
                                            <input
                                                name='useridno'
                                                className='outline_none'
                                                type='text'
                                                value={userInfo.useridno}
                                                onChange={handleInputChange}
                                                placeholder='아이디 입력'
                                                aria-label='아이디 입력'
                                                onKeyDown={(e) => activeEnter(e)}
                                                onFocus={() => setIsIdFocused(true)}
                                                onBlur={() => setIsIdFocused(false)} />
                                        </div>
                                        <div className={`idpw_input items-center ${isError && !isPwFocused ? 'idpw_input_error' : ''}`}>
                                            <div className='border-r pr-2 mr-2 items-center'>
                                                <Theme.InputPw className={isPwFocused ? 'co_dark' : isError ? 'co_red' : 'co_light'} />
                                            </div>
                                            <input
                                                name='userpswd'
                                                className='outline_none'
                                                type={showPassword ? 'text' : 'password'}
                                                maxLength={20} value={userInfo.userpswd}
                                                onChange={handleInputChange}
                                                placeholder='비밀번호 입력'
                                                aria-label='비밀번호 입력'
                                                onKeyDown={(e) => activeEnter(e)}
                                                onFocus={() => setIsPwFocused(true)}
                                                onBlur={() => setIsPwFocused(false)} />
                                            <div className='cursor-pointer' onClick={togglePassword}>
                                                <button aria-label={showPassword ? '비밀번호 숨기기' : '비밀번호 표시'}>{showPassword ? <Icons.PwEyeOn /> : <Icons.PwEyeNon />}</button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                : loginStep === 'otp_login' ?
                                    <>
                                        <div>
                                            2차 인증을 진행합니다.<br />
                                            구글 OTP를 분실하신 경우 재발급 바랍니다.
                                        </div>
                                        {errorMsg}
                                        <div className='flex gap-2 m-auto'>
                                            {otp.map((digit, index) => (
                                                <div key={index} className='divide_otp'>
                                                    <input
                                                        type='text'
                                                        inputMode='numeric'
                                                        maxLength='1'
                                                        value={digit}
                                                        onChange={(e) => handleOtpChange(e.target.value, index)}
                                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                                        ref={(el) => (inputs.current[index] = el)}
                                                        className={`register_otp text_otp_media_set ${isError ? 'co_red bg_tr_row' : ' bg_co_line'}`}
                                                        aria-label={`OTP 번호 ${index + 1}번째 자리`}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                        <div className='link_box' onClick={handleClearAll}><button>재입력</button></div>
                                    </>
                                    : loginStep === 'otp_issuance' ?
                                        <>
                                            <img className='qr_img' src={otpInfo.otpurl} alt='new Qrcode'></img>
                                            <div>
                                                상단의 QR코드를 스캔하여 구글 OTP 등록 후<br />
                                                화면에 보이는 인증 코드 6자리로 로그인을 진행해주세요.<br />
                                                재발급이신 경우, 기존의 인증 내역은 <br />
                                                오른쪽에서 왼쪽으로 슬라이드 하여 삭제하여 주시기 바랍니다.
                                            </div>
                                            {errorMsg}
                                            <div className='flex gap-2 justify-center'>
                                                {otp.map((digit, index) => (
                                                    <div key={index} className='divide_otp'>
                                                        <input
                                                            type='text'
                                                            inputMode='numeric'
                                                            maxLength='1'
                                                            value={digit}
                                                            onChange={(e) => handleOtpChange(e.target.value, index)}
                                                            onKeyDown={(e) => handleKeyDown(e, index)}
                                                            ref={(el) => (inputs.current[index] = el)}
                                                            className={`register_otp text_otp_media_set ${isError ? 'co_red bg_tr_row' : ' bg_co_line'}`}
                                                            aria-label={`OTP 번호 ${index + 1}번째 자리`}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                            <div className='link_box' onClick={handleClearAll}><button>재입력</button></div>
                                        </> : ''
                            }
                            <div className='modal_btn_box h-12'>
                                {loginStep !== 'first_step' && <button onClick={back} className='comm_btn_w w-half'>뒤로</button>}
                                <button onClick={login} className={`comm_btn bg_co_black ${loginStep !== 'first_step' ? 'w-half' : 'w-full'}`}
                                        disabled={!((loginStep === 'first_step' && userInfo.useridno !== '' && userInfo.userpswd !== '') || ((loginStep === 'otp_issuance' || loginStep === 'otp_login') && isOtpComplete))}>
                                        로그인</button>
                            </div>
                        </div>
                        {loginStep !== 'otp_issuance' ? <hr className='w-full' /> : ''}
                        {loginStep === 'first_step' ?
                            <div className='link_box'>
                                <button onClick={signIn}>회원가입</button>
                                <span>&ensp;|&ensp;</span>
                                <button onClick={findIdPw}>아이디/비밀번호 찾기</button>
                            </div>
                            :
                            loginStep === 'otp_login' ? <><div className='link_box' onClick={reIssuance}><button>구글 OTP 재발급하기</button></div></> : ''}
                        <Icons.LogoIcoOpen className='mt-auto' />
                    </div>
                </div>
            </div>
        </div >
    )
}


export default Login